import Typography from '@mui/material/Typography';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const ErrorMessage = styled(Typography)`
	margin-top: ${({ theme }) => theme.spacing(1)};
	color: #9f0000;
`;
